import { useState } from "react";
import { Box } from "@mui/material"
import { BackDropLoader } from "../../loader/BackDropLoader";
import { Top } from "./Top";
import { Form } from "./Form";
import { Bottom } from "./Bottom";
import dayjs from "dayjs";

export const Setup = ({loc, __SESSION}) => {
    let user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);

    let decoded = loc ? JSON.parse(window.atob(loc)) : {}

    let type = decoded.type
    let target = decoded.branch_id
    let cutoff_time = decoded.cutoff_time

    const [cutoffForm, setCutoffForm] = useState({
        type: type,
        target: target,
        error: {
            stat: loc === 'create',
            code: false,
            name: false,
            msg: 'Fields Required!'
        },
        cutoff_time: cutoff_time
            ? dayjs(cutoff_time, "HH:mm")
            : dayjs("00:00", "HH:mm")
    });
    
    const [submitFormLoader, setSubmitFormLoader] = useState({submit:true, loader:false})
    
    return (
        <Box height="100%" width="100%" borderRadius="12px" display="flex" flexDirection="column" justifyContent="flex-start" gap={3}>
            <Top loc={loc}/>
            <Box minHeight="10px" my={-1.5} fontSize={10} textAlign="right" color="red">All Input Fields are Required *</Box>
            <Form loc={loc} setCutoffForm={setCutoffForm} cutoffForm={cutoffForm}/>
            <Bottom loc={loc} submitFormLoader={submitFormLoader} cutoffForm={cutoffForm} user_id={user_id} __SESSION={__SESSION} setSubmitFormLoader={setSubmitFormLoader}/>
            <BackDropLoader  submitFormLoader={submitFormLoader}/>
        </Box>
    )
}